import { getBrandArticleUrl } from '@/store/modules/support/support.helpers';

/* eslint-disable import/prefer-default-export */
export const LsServiceItemQuickActionsConstants = {
  messageCrew: {
    title: 'Message My Crew',
    route: {
      name: 'inbox',
    },
    trackId: 'ls_service_item_quick_actions-inbox',
  },
  serviceHistory: {
    title: 'Service Details',
    route: {
      name: 'serviceDetails',
      params: {},
    },
    trackId: 'ls_service_item_quick_actions-service_details',
  },
  instantQuoteDetails: {
    title: 'Service Details',
    route: {
      name: 'instantQuoteDetails',
      params: {},
    },
    trackId: 'ls_service_item_quick_actions-service_details',
  },
  manualQuoteDetails: {
    title: 'Service Details',
    route: {
      name: 'quoteDetails',
      params: {},
    },
    trackId: 'ls_service_item_quick_actions-service_details',
  },
  longGrassFee: {
    title: 'Long Grass Fee',
    // eslint-disable-next-line
        url: getBrandArticleUrl('longGrassFee'),
    trackId: 'ls_service_item_quick_actions-long_grass_fee',
  },
  trustFee: {
    title: 'Trust & Safety Fee',
    // eslint-disable-next-line
        url: getBrandArticleUrl('trustAndSafetyFee'),
    trackId: 'ls_service_item_quick_actions-trust_safety_fee',
  },
  threeCutPolicy: {
    title: '3-Cut Policy',
    // eslint-disable-next-line
        url: getBrandArticleUrl('threeCutPolicy'),
    trackId: 'ls_service_item_quick_actions-3_cut_policy',
  },
  skipService: {
    title: 'Skip Service',
    route: {
      name: 'skipMow',
    },
    trackId: 'ls_service_item_quick_actions-skip',
  },
  pauseService: {
    title: 'Pause Service',
    route: {
      name: 'pauseSubscription',
    },
    trackId: 'ls_service_item_quick_actions-pause',
  },
  contactSupport: {
    title: 'Contact Support',
    route: {
      name: 'messageLS',
    },
    trackId: 'ls_service_item_quick_actions-contact_support',
  },
};
